import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getERPSalesReportHomeSummary } from '@/service/erpAPI';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchERPSalesReportHomeSummary = createAsyncThunk(
  'erpSalesReportHomeSummary/fetchERPSalesReportHomeSummary',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getERPSalesReportHomeSummary(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP销售快报首页概况数据失败');
    }
  }
)

const erpSalesReportHomeSummarySlice = createSlice({
  name: 'erpSalesReportHomeSummary',
  initialState: defaultState,
  reducers: {
    resetERPSalesReportHomeSummaryState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPSalesReportHomeSummary.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchERPSalesReportHomeSummary.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchERPSalesReportHomeSummary.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetERPSalesReportHomeSummaryState } = erpSalesReportHomeSummarySlice.actions;
export default erpSalesReportHomeSummarySlice.reducer;
